<template>
	<v-tooltip
		bottom
		:max-width="maxWidth"
		nudge-bottom="10">
		<template v-slot:activator="{ on, attrs }">
			<span v-on="on" v-bind="attrs"><slot></slot></span>
		</template>
		<span>{{ text ? text.substr(0, 500) : '' }}</span>
	</v-tooltip>
</template>

<script>
export default {
	props: {
		maxWidth: {
			type: [String, Number],
			default: 400,
		},
		text: String,
	},
}
</script>
